/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
// there must be a type called ProcessType already, hence the no-shadow error.
export enum ProcessType {
  Approvals = 'Approvals',
  Payouts = 'Payouts'
}
